import {type LocalTimeValue} from 'web-app/react/components/form-elements/timepicker/timepicker';

export interface BaseAPIData {
    from: string | null;
    to: string | null;
    duringWeekends: boolean | null;
    active?: boolean;
}

export type APIData = BaseAPIData | null;

export interface FormData {
    from: LocalTimeValue | null;
    to: LocalTimeValue | null;
    active: ActiveState;
    disableWeekends: boolean | null;
}

export enum ActiveState {
    enabled = 'enabled',
    disabled = 'disabled',
}

export interface Option {
    value: string;
    label: string;
}
